import React, { PureComponent } from 'react';
import Calender from './calender';
import CalendarOptions from './calender-options';

class CalenderPanel extends PureComponent {
    
    render(){
        const { clazz, showProductlist, isBuilder } = this.props;

        return (
            <div className={`calender-panel round-corners ${clazz || ""}`}>
                <div className="clearfix">
                    <div className="col col-12">
                        { showProductlist && <CalendarOptions /> }
                        <Calender isBuilder={isBuilder} />
                    </div>
                </div>
            </div>
        )
    }
}

export default CalenderPanel;